import { observer } from 'mobx-react';
import CheckmarkIcon from '../../../../../../Cutesies/CheckmarkIcon';
import Modal from '../../../../../../Modal';
import { default as InviteParticipantStore } from '../../Store';
import Body from './Body';

export interface Props {
  store: InviteParticipantStore;
  successfulCommunicationsCount: number;
  sendEmailDate: Date;
  skipCommunications: boolean;
}

export const resetModal = (store: InviteParticipantStore) => {
  store.modalStore.close();
  store.getLicenseInformation();
};

function ParticipantsInvitedModal({
  store,
  successfulCommunicationsCount,
  sendEmailDate,
  skipCommunications,
}: Props) {
  switch (store.modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          title={<CheckmarkIcon className="mx-auto mt-16" />}
          close={() => resetModal(store)}
          customBackgroundCssClasses="bg-teal-100 opacity-60"
          additionalClasses="text-center"
          modalWidth="w-2/5"
        >
          <Body
            store={store}
            successfulCommunicationsCount={successfulCommunicationsCount}
            sendEmailDate={sendEmailDate}
            skipCommunications={skipCommunications}
          />
        </Modal>
      );
  }
}

export default observer(ParticipantsInvitedModal);
